<header *ngIf='userSession' class='AuthenticatedHeader'>
  <div>
    <div class='AuthenticatedHeader-image flex-grow-0 pt-3'>
      <a href='/'>
        <img
          alt='Retreva Logo'
          height='85'
          src='assets/images/Group-3789.svg' />
      </a>
    </div>
    <div class='AuthenticatedHeader-bars flex-grow-0'>
      <fa-icon
        (click)='toggleLeftMenu()'
        [icon]='bars'
        [size]="'2x'"
        class='AuthenticatedHeader-bars-icon'></fa-icon>
    </div>
  </div>
  <div class='AuthenticatedHeader--menu'>
    <p class='mb-0 pe-5 mt-3 AuthenticatedHeader--menu--welcome'>
      Welcome {{ userSession.first_name }} {{
        userSession.last_name
      }}<span
      *ngIf="userSession.user_type === 'user' && userSession.vsm_group_id"
      class='vsm-dogo text-right'
    ><app-svg-renderer [svg]="'Support Icon'"></app-svg-renderer
    ></span>
    </p>
    <div class='AuthenticatedHeader--menu-container'>
      <div *ngIf='showReportInformation' [class.alert-danger]='reportEventData?.result !== "success"'
           class='alert alert-warning d-flex flex-row align-items-center'>
        <ng-container *ngIf='reportEventData?.completed; else notReady'>
          <p class='mb-0'>{{ reportEventData?.message }}</p>
          <app-button *ngIf='reportEventData?.result === "success"' [Click]='downloadReportButton.onClick'
                      [color]='downloadReportButton.color' [size]='downloadReportButton.size'
                      [text]='downloadReportButton.text' class='ms-3'></app-button>
        </ng-container>
        <ng-template #notReady>
          <p class='mb-0'>Please, wait for your report to be ready</p>
          <mat-spinner class='ms-3' diameter='25'></mat-spinner>
        </ng-template>
      </div>
      <app-authenticated-header-menu></app-authenticated-header-menu>
    </div>
  </div>
</header>
